import {Fragment} from "react";
import {formEl} from "../constants";
import {QuestionTypes} from "../../../types/Question";
import CustomRichTextEditor from "../../form/input/CustomRichTextEditor";
import Paper from "../../ui/customs/Paper";
import Select from "../../form/Select";
import {Copy, GripVertical, Trash2} from "lucide-react";
import MyEditor5 from "../../form/input/MyEditor5";

type NumberInputProps = {
    item: {
        id: string;
        uid: string;
        title: string;
        type: string;
        required: boolean;
    };
    handleValue: (id: string, newValue: string, type: QuestionTypes) => void;
    deleteEl: (uuid: {id?: string, uid: string}) => void;
    handleRequired: (id: string) => void;
    handleElType: (id: string, value: QuestionTypes) => void;
    duplicateElement: (id: string, type: QuestionTypes) => void;
    isSubQuestion?: boolean;
};

const NumberInput: React.FC<NumberInputProps> = ({
                                                     item,
                                                     handleValue,
                                                     deleteEl,
                                                     handleRequired,
                                                     handleElType,
                                                     duplicateElement,
                                                     isSubQuestion,
                                                 }) => {
    return (
        <Fragment>
            <Paper className="mb-4">
                <div className="flex justify-between items-center mb-4">
                    <GripVertical className="text-gray-400 cursor-move"/>
                    <div className="w-1/4">
                        {isSubQuestion ? (
                            <Select
                                defaultValue={QuestionTypes.QUESTION_TYPE_SINGLE.toString()}
                                onChange={(val) => handleElType(item.id, Number(val))}
                                options={formEl.filter((el) => !el.hasChildren)
                                    .map((el) => ({
                                    label: el.label,
                                    value: String(el.value),
                                }))}
                            />
                        ) : (
                            <Select
                                defaultValue={QuestionTypes.QUESTION_TYPE_SINGLE.toString()}
                                onChange={(val) => handleElType(item.id, Number(val))}
                                options={formEl.map((el) => ({
                                    label: el.label,
                                    value: String(el.value),
                                }))}
                            />
                        )}
                    </div>
                </div>

                <div className="p-4 bg-white border-b space-y-4">
                    <MyEditor5
                        content={item.title}
                        onBlur={(value) => handleValue(item.id, value, QuestionTypes.QUESTION_TYPE_SINGLE)}
                    />
                </div>

                <input
                    type="number"
                    disabled
                    placeholder="(Input number)"
                    className="w-full border border-gray-300 rounded px-3 py-2 bg-gray-100 text-sm text-gray-500 cursor-not-allowed"
                />

                <div className="mt-4 flex items-center space-x-4 border-t pt-3">
                    <button
                        className="text-gray-500 hover:text-gray-800"
                        onClick={() => deleteEl({ id: item.id, uid: item.uid })}
                        title="Xoá phần tử"
                    >
                        <Trash2 size={18}/>
                    </button>
                    <button
                        className="text-gray-500 hover:text-gray-800"
                        onClick={() => duplicateElement(item.id, QuestionTypes.QUESTION_TYPE_SINGLE)}
                        title="Nhân bản"
                    >
                        <Copy size={18}/>
                    </button>

                    <label className="inline-flex items-center ml-auto text-sm text-gray-600">
                        <input
                            type="checkbox"
                            checked={item.required}
                            onChange={() => handleRequired(item.id)}
                            className="mr-2"
                        />
                        Bắt buộc
                    </label>
                </div>
            </Paper>
        </Fragment>
    );
};

export default NumberInput;
